import { createContext, useContext } from 'react'

export type ProfileImage = {
  url: string
  height?: number
  width?: number
  showInRoundRect?: boolean
}

export interface Wisdom {
  appleStoreInfo?: string
  appleStoreUrl?: string
  disclaimer: string
  chatName: string
  titleName?: string
  exampleQuestions: string[]
  hideHeader?: boolean
  hideHamburgerMenu?: boolean
  hideBrandingLinkFooter?: boolean
  initialMessage?: string
  profileGreeting: string
  profileImage: ProfileImage
  termsOfService?: string
  privacyPolicy?: string
  termsOfServiceUrl: string
  privacyPolicyUrl: string
  showConsentGate?: boolean
  legalNote?: string
  titleIconUrl: string
  venueSpec?: string
  isCalendarAuthed: boolean
  isInstagramAuthed: boolean
  chatNameColors?: {
    assistant?: {
      background?: string
      text?: string
    }
    user?: {
      background?: string
      text?: string
    }
  }
}

interface WisdomContextType {
  wisdom: Wisdom
  setWisdom: (wisdom: Wisdom) => void
  updateWisdom: (updates: Partial<Wisdom>) => Promise<void>
  googleDeauth: () => Promise<void>
  instagramDeauth: () => Promise<void>
}

export const WisdomContext = createContext<WisdomContextType>({
  wisdom: {} as Wisdom,
  setWisdom: () => {},
  updateWisdom: async () => {},
  googleDeauth: async () => {},
  instagramDeauth: async () => {},
})

export function useWisdom() {
  const context = useContext(WisdomContext)
  if (context === undefined) {
    throw new Error('useWisdom must be used within a WisdomProvider')
  }
  return context
}
